export default class Api {
  constructor(el, opt) {
    this.$el = $(el)
    this.defaults = {
      data: {
        absolute: 0,
        endIndex: 1,
        firstIndex: 1,
        indexPage: 1,
        maxRows: 20,
        nextIndex: 1,
        pageCount: 20,
        prevIndex: 1,
        skip: false,
        totalCount: 0,
        totalPage: 1,
        getAbsolute: {},
        getEndPage: {},
        getFirstPage: {},
        getNextPage: {},
        getPrevPage: {},
        getTotalPage: {}
      },
      events: {}
    }
    this.settings = Object.assign({}, this.defaults, opt)
    this._data = this.settings.data
  }

  set data(value) {
    if ($.type(value) === 'object') {
      this._data = value
      this.update(value)
    }
  }

  get data() {
    return this._data
  }
}
